<script setup>
import {computed} from 'vue'
import {useNavigationStore} from '@/stores/navigation'
import NavigationMobileGroup from './NavigationMobileGroup.vue'
import Button from '@/common/Button.vue'

defineProps({
    closeMenu: Function,
})

// Pinia Store
const navigationStore = useNavigationStore()

// Computed properties
const navigationGroups = computed(() => {
    return navigationStore.groups
})
</script>

<template>
    <div>
        <div class="text-end mb-2" @click.stop>
            <Button class="btn-sm" @click="closeMenu">
                <i class="bi-x-lg"/>
                close
            </Button>
        </div>

        <div class="list-group navigation-mobile-group-list-group">
            <NavigationMobileGroup v-for="groupName in navigationGroups" :key="groupName" :close-menu="closeMenu"
                                   :group-name="groupName"/>
        </div>

        <div class="text-end">
            <Button class="btn-sm" @click="closeMenu">
                <i class="bi-x-lg"/>
                close
            </Button>
        </div>
    </div>
</template>

<style scoped>
.navigation-mobile-group-list-group {
    margin-bottom: 10px;
}
</style>